import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "./Button";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate(-1)}
      type="button"
      title="Go Back"
      isBackgroundColor={false}
      icon="mdi mdi-arrow-left mr-2"
      className="btn mb-2 text-white btn-dark btn-sm"
    />
  );
};

export default BackButton;
